import { styled } from '@mui/material/styles';
import { TextField, Select, MenuItem } from '@mui/material/';
import { ArrowDownCaret } from '../../global/Icons';

export const CstmTextField = styled(TextField)({
    "& .css-vyjyf0-MuiFormLabel-root-MuiInputLabel-root": {
        color: "#0059BE !important",
    },
    // "& .MuiOutlinedInput-root": {
    //     color: "#0059BE !important",
    // },
    '&:hover fieldset': {
        borderColor: '#11783C !important',
    },
    "& .MuiFormHelperText-root.Mui-error": {
        color: "#F3284B !important"
    },
    '& input:valid + fieldset': {
        borderRadius: '12px !important',
    },
    '& .Mui-disabled': {
        borderRadius: '12px !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '12px !important',
    }, 
    '.css-1ewifw0-MuiButtonBase-root-MuiChip-root':{
        backgroundColor:'#558AC7 !important',
        borderRadius:'10px'
    }
}); 
// SIR PHILIP STANDARD DURING UI TRAINING DESIGN
export const StndrdTextField = styled(TextField)({
	borderRadius: '6px',
    '& .MuiOutlinedInput-root': {
    borderRadius: '6px', borderWidth: '1px', 
        '& input': {
            fontSize: '14px',
			color: '#292C2F',
			'&::placeholder': {
				color: '#8F969D', // your custom placeholder color
				opacity: 1,       // ensure color is fully applied
			},
        },
        '& fieldset': {
            borderColor: '#B5BBC1', // default state
        }, 
        '&.Mui-focused fieldset': {
            borderColor: '#003F2E', // when focused
            boxShadow: '0 0 0 6px rgba(0, 48, 34, 0.24)',
        },
        '&:hover fieldset': {
            borderColor: '#003F2E', // on hover E34935
        }, 
        '&.Mui-error fieldset': {
            borderColor: '#E34935', // when error is true
        },
		'&.Mui-disabled': {
			backgroundColor: '#F7F8F8' // your custom disabled background
		},
        '&.Mui-disabled fieldset': { // when disabled
            borderColor: '#B5BBC1',
        },
    },
	'& .MuiFormHelperText-root': {
		marginLeft: '8px !important', // adding margin-left to the helper text
	},
	'& .MuiFormHelperText-root.Mui-error': {
		color: '#B6174B', // helper text when error
	},
}); 

export const StndrdSelect = styled((props) => (
	<Select {...props} IconComponent={ArrowDownCaret} MenuProps={{
		PaperProps: {
			sx: {
				boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.08), 0px 0px 4px rgba(0, 0, 0, 0.04)",
				borderRadius: "6px",
			},
		},
    }}/>))({
	borderRadius: "6px",
	"& .MuiSelect-icon": {
		top: "50%",
		transform: "translateY(-50%)",
	},
	"& .MuiSelect-select": {
		fontSize: "14px",
		padding: "8.5px 0px 8.5px 14px",
		color: "#292C2F",
	},
	"& fieldset": {
		borderColor: "#B5BBC1",
	},
	"&.Mui-focused fieldset": {
		borderColor: "#5E58D4",
	},
	"&:hover fieldset": {
		borderColor: "#5E58D4",
	},
	"&.Mui-disabled": {
		backgroundColor: "#F7F8F8",
	},
	"&.Mui-disabled fieldset": {
		borderColor: "#B5BBC1",
	},
});

export const StndrdMenuItem = styled(MenuItem)({
	padding: "12px 16px",
	fontSize: "14px",
	"&.Mui-selected": {
		backgroundColor: "#fff !important",
	},
	"&.Mui-selected:hover": {
		backgroundColor: "#E7E8EA !important",
	},
});